import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleFormatService } from 'src/core/services';
import { LanguageStore } from 'src/core/stores';

@Pipe({
  name: 'localeRelativeTime',
  standalone: true,
  pure: false,
})
export class LocaleRelativeTimePipe implements PipeTransform {
  private readonly localeFormatService = inject(LocaleFormatService);
  private readonly languageStore = inject(LanguageStore);

  transform(
    value: Date | string | number | null | undefined,
    relativeTimeStyle: 'long' | 'short' | 'narrow' = 'long',
    numericStyle: 'auto' | 'always' = 'auto',
  ): string {
    void this.languageStore.locale();
    return this.localeFormatService.formatRelativeTime(
      value,
      relativeTimeStyle,
      numericStyle,
    );
  }
}
